import React, { Component, Fragment } from 'react';
import { Card, CardBody } from 'reactstrap';

import ResponseBlockGenerator from '../components/ResponseBlockGenerator';
import { gAPI_Special_Emergenices } from '../../../../../constants/APIs';

export default class SpecialEmergencies extends Component {
  render() {
    return (
      <Fragment>
        <Card>
          <CardBody>
            <ResponseBlockGenerator getUrl={gAPI_Special_Emergenices} />
          </CardBody>
        </Card>
      </Fragment>
    );
  }
}
